import { UserResource } from "@/services";

export const unique = {
  getMessage: field => "This " + field + " is already taken.",
  validate: (value, args) => {
    let data = {};
    data[args[0]] = value;

    return UserResource.checkUnique(data)
      .then(response => {
        var result = response.body;
        return {
          valid: !result[args[0]].exists
        };
      })
      .catch(e => {
        return {
          valid: false
        };
      });
  }
};
